import { createContext, FC, ReactNode, useContext } from "react";
import { useLiveAPI, UseLiveAPIResults } from "../hooks/use-live-api";

const LiveAPIContext = createContext<UseLiveAPIResults | undefined>(undefined);

export type LiveAPIProviderProps = {
  children: ReactNode;
  audioInitialBufferMs?: number;
  outputPrimeOnConnect?: boolean;
};

export const LiveAPIProvider: FC<LiveAPIProviderProps> = ({
  audioInitialBufferMs,
  outputPrimeOnConnect,
  children,
}) => {
  const liveAPI = useLiveAPI(audioInitialBufferMs, outputPrimeOnConnect);

  return (
    <LiveAPIContext.Provider value={liveAPI}>
      {children}
    </LiveAPIContext.Provider>
  );
};

export const useLiveAPIContext = () => {
  const context = useContext(LiveAPIContext);
  if (!context) {
    throw new Error("useLiveAPIContext must be used within a LiveAPIProvider");
  }
  return context;
};
